export default __webpack_public_path__ + "static/media/account-gray.51f56be6.svg";